import { render, staticRenderFns } from "./v-card.vue?vue&type=template&id=50547e8b&scoped=true&"
import script from "./v-card.vue?vue&type=script&lang=js&"
export * from "./v-card.vue?vue&type=script&lang=js&"
import style0 from "./v-card.vue?vue&type=style&index=0&id=50547e8b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50547e8b",
  null
  
)

export default component.exports